import React, { useState, useRef, useEffect } from 'react';


import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import TextField from '../components/TextField'
import ImageButton from '../components/ImageButton'

import SendImage from '../images/send.png'
import GlowImage from '../images/glow.png'
import ArrowUp from '../images/arrow-up.svg'
import ChatBubble from '../components/ChatBubble'
import ClinicBubble from '../components/ClinicBubble'
import "../components/ChatBubble.css"
import "./Chat.css"

/* Thinking bubble component */
function ThinkingBubble(props) {
    return (
        <div className = "thinking-bubble" style = {{display: props.thinking, gap: '4px', justifyContent: 'center', marginTop: '20px'}}>
            <div className = "loading-dot loading-dot-1"></div>
            <div className = "loading-dot loading-dot-2"></div>
            <div className = "loading-dot loading-dot-3"></div>
        </div>
    )
}

/* Chat wrapper component */
export default function Chat() {

    const [thinking, setThinking] = useState('none');
    const [chatLogs, setChatLogs] = useState([
            {role: 'assistant', content: 'Hi! My name is KC Social Nest. My goal is to help you find healthcare resources that fit your needs. To begin, send me a message!', type: 'chat'},
    ]);

    const chatLogsRef = useRef(null);

    useEffect(() => {
        if (chatLogsRef.current) {
            chatLogsRef.current.scrollTop = chatLogsRef.current.scrollHeight;
            console.log("Scrolling to the bottom");
        }
    }, [chatLogs, thinking]);

    /* Function called when a user sends a chat */
    async function sendChat() {
        const userChat = document.getElementById("user-chat").value;

        if (!userChat || userChat.trim() === '') {
            return;
        }

        /* Clear input immediately */
        document.getElementById("user-chat").value = '';

        /* Add user chat bubble */
        setChatLogs(function (prevLogs) {
            return [...prevLogs, { role: 'user', content: userChat, type: 'chat'}];
        });

        /* Add loading bubble */
        setThinking('flex');

        const updatedChatLogs = [...chatLogs, { role: 'user', content: userChat, type: 'chat'}]; // unattached to state for immediate use

        // Build conversation payload: remove any non-chat entries (e.g. clinic rows / filtered_df)
        const conversation = updatedChatLogs
            .filter(item => item.type === 'chat')
            .map(item => ({ role: item.role, content: item.content }));

        /* Call API */

        /* prod */
        /* https://api-handler-19864279100.us-central1.run.app/api/message */
        // https://kc-social-nest-backend-411263313199.us-central1.run.app
        // http://127.0.0.1:8080/api/message
        const response = await fetch('https://kc-social-nest-backend-411263313199.us-central1.run.app/api/message', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                conversation
            }),
        }) 
        const data = await response.json();
        console.log(data);

        /* Hide thinking bubble */
        setThinking('none');

        /* Add ChatBot chat bubble */
        setChatLogs(function (prevLogs) {
            var newChatLogs = [...prevLogs, { content: data['final_response'], role: 'assistant', type: 'chat' }];
            if (data["filtered_df"] != undefined) {
                for (var i = 0; i < data["filtered_df"].length; i++) {
                    newChatLogs.push({ content: data["filtered_df"][i], role: 'assistant', type: 'clinic' });
                }
            }
            return newChatLogs;
        });

        /* Add ChatBot sources link */

    }

    /* Keep track of chat bubbles */    
    return (
        <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
            <Navbar/>

            {/* Title */}

            <div style = {{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                maxHeight: '90%',
                minHeight: 0,
                maxWidth: '600px',
                marginLeft: 'auto',
                marginRight: 'auto',
            }}>
                <h1 style = {{textAlign:'center', marginTop: '100px'}}>Chat Page</h1>
                <div id = "chat-logs" ref={chatLogsRef} style = 
                {{
                    flex: 1,
                    minHeight: 0,          // VERY important for flex children
                    maxWidth: '600px',
                    width: '100%',
                    margin: '20px auto 0 auto',
                    display: 'flex',
                    flexDirection: 'column',
                    rowGap: '20px',
                    overflowY: 'auto',      // let flex decide height
                    zIndex: 100
                    }}>
                    {chatLogs.map((text, index) => (
                        text["type"] == 'chat' ? 
                        <ChatBubble key={index} text={text['content']} user = {text['role'] == 'assistant' ? "KC Social Nest" : "You"} /> 
                        :
                        <ClinicBubble key={index} title = {text['content']['Title']} text={text['content']['Purpose']} link = {text['content']['Website']} address = {"" + text['content']['Address'] + ", " + text['content']['City'] + ", " + text['content']['State'] + " " + text['content']['Zip']}/>
                    ))}
                    <ThinkingBubble thinking={thinking}/>
                </div>

                {/* Send Message Interface */}
                <div id = "chat-interface" style = {{display: 'flex', flexWrap: 'nowrap', height: '50px', justifyContent: 'center', columnGap: '6px', width: '100%', marginLeft: 'auto', marginRight: 'auto', marginTop: '20px',boxSizing: 'border-box', border: 'solid 1px rgba(255, 255, 255, 0.3)', borderRadius: '7px'}}>
                    <TextField inputId = "user-chat" width = '90%' placeholder="Placeholder text" outline = '0px' onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();   // prevents newline or form submission
                        sendChat();
                    }
                }}/>
                    <ImageButton img={SendImage} width='24px' height = '24px' marginBottom = '2px' onClick = {sendChat}/>
                </div>
            </div>

            {/* Glow Bubble */}
            {/* <div style = {{position: 'absolute', width: '100vw', textAlign: 'center', maxHeight: '900px', left: '0', top: '0', zIndex: '-3'}}>
                <img src = {GlowImage} style = {{zIndex:-3, textAlign: 'center', height: '100%', width: '100%'}}/>
            </div> */}

            {/* No footer for this page */}
            {/* <Footer/> */}
        </div>
    )
}